function checkBannerVisibility() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;

    let bgDiv = document.querySelector('.shopify-pc__banner_bg');
    if (!bgDiv) {
        bgDiv = document.createElement('div');
        bgDiv.className = 'shopify-pc__banner_bg';
        banner.parentNode.insertBefore(bgDiv, banner.nextSibling);
    }

    const style = window.getComputedStyle(banner);
    const isVisible = (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        banner.offsetHeight > 0
    );

    if (isVisible) {
        document.body.style.overflow = 'hidden';
        bgDiv.style.display = 'block';
    } else {
        document.body.style.overflow = '';
        bgDiv.style.display = 'none';
    }
}

const observer = new MutationObserver(function(mutationsList, observer) {
    checkBannerVisibility();
});

observer.observe(document.body, { childList: true, subtree: true, attributes: true });

setInterval(checkBannerVisibility, 500);
